import { useNavigate } from 'react-router-dom';
import { PAGES, PREFIX_PATH } from '../../utils/GlobalParams';
import './RouteToDateFlow.css'
import { mySteps, myStepsMOBILE } from '../../utils/stepperUtils';
import { setSteps } from '../../store/MahutiReducer';
import { useDispatch, useSelector } from 'react-redux';
import { isMobile } from "react-device-detect";
export default function RouteToDateFlow(props) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const store = useSelector(store => store.reducer);
    let lpPrefix = store.lpName ? '/' + store.lpName : '';
    let steps = isMobile ? myStepsMOBILE : mySteps

    return <div className="RouteToDateFlow pt-4 pb-3 px-4 px-lg-0">
        {!props.isLPLoading ? <h1> {props.landingPageParams?.Date_Flow_Title__c}? </h1> : <div className='span'><div className='loader' /></div>}
        <h2>{props.landingPageParams?.Date_Flow_Subtitle__c}</h2>
        <button disabled={props.isLPLoading} className="btn-primary" onClick={() => {navigate(`${PREFIX_PATH}${lpPrefix}/${PAGES.DATE_FLOW}`); dispatch(setSteps(steps))}}>{!props.isLPLoading ? props.landingPageParams?.Date_Flow_Button_Text__c : <div className='span'><div className='loader bg-light' /></div>}</button>
    </div>
}